import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'

const GalleryChevronRightIcon = (props) => {
    return (
        <Icon viewBox="0 0 16 16" fill="none" {...props} aria-hidden="true">
            <path
                d="M6 12L10 8L6 4"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Icon>
    )
}

GalleryChevronRightIcon.propTypes = {onClick: PropTypes.func}

export default GalleryChevronRightIcon
